import { render, staticRenderFns } from "./lsDistToRegForm.vue?vue&type=template&id=5770e5ae&scoped=true&"
import script from "./lsDistToRegForm.vue?vue&type=script&lang=js&"
export * from "./lsDistToRegForm.vue?vue&type=script&lang=js&"
import style0 from "./lsDistToRegForm.vue?vue&type=style&index=0&id=5770e5ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5770e5ae",
  null
  
)

export default component.exports